import type VendorRM from 'ab-requestModels/vendor/vendor.requestModel';

import { isValidTextInput } from '@acceligentllc/shared/utils/text';

export function validate(values: VendorRM) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	return errors;
}
